var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6815 8.79189C9.40403 8.51441 9.40403 8.06453 9.6815 7.78706L12.258 5.21056H0.710526C0.318113 5.21056 0 4.89245 0 4.50003C0 4.10762 0.318113 3.78951 0.710526 3.78951H12.2581L9.6815 1.21294C9.40403 0.935466 9.40403 0.485586 9.6815 0.208108C9.95898 -0.0693695 10.4089 -0.0693695 10.6863 0.208108L14.4758 3.99758C14.7533 4.27506 14.7533 4.72494 14.4758 5.00242L10.6863 8.79189C10.4089 9.06937 9.95898 9.06937 9.6815 8.79189Z",
    fill: "#00A3A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsLink);
export default __webpack_public_path__ + "static/media/ArrowsLink.8529f477964940be7ecc5f0dde486aa7.svg";
export { ForwardRef as ReactComponent };